import { constructS3Url } from 'utils'

type Props = {
  imageUrl?: string
  imageUrlS3?: string
  fallbackS3URL?: string
}

export const getImageUrl = ({ imageUrl, imageUrlS3, fallbackS3URL }: Props): string | null => {
  // Prioritize image url coming from Hygraph Assets if available
  if (imageUrl) return imageUrl
  //Check ImageS3 fallback (Only for Image components not Assets)
  if (imageUrlS3) return constructS3Url(imageUrlS3)
  // Fall back to S3 URL if available
  if (fallbackS3URL) return constructS3Url(fallbackS3URL)

  return null
}
